import { SlideAction } from "./slide-action.model";
export class Slide {
  _id: string;
  title: string = "";
  subtitle: string = "";
  content: string = "";
  contentPosition: "top" | "right" | "bottom" | "left" | "center" = "right";
  textColor: "light" | "dark" = "light";
  textBackground: "none" | "light" | "dark" = "none";
  backgroundImage: string = "";
  backgroundVideo: string = "";
  image: string = "";
  imageMobile: string = "";
  backgroundHorizontalPosition: "left" | "right" | "center" = "center";
  backgroundVerticalPosition: "left" | "right" | "center" = "center";
  position: number = 0;
  active: boolean = false;
  actions: Array<SlideAction> = [];
  completedLocales: Array<String> = [];
}



// WEBPACK FOOTER //
// ./libs/atenea-cms-brand/src/home-slider/shared/slide.model.ts